/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ScDataUnlistedModel,
  ScDataUnlistedModelBulkInput,
  ScDataUnlistedModelLinkInput,
  ScDataUnlistedModels,
  ScDataUnlistedModelsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Unlisted models list
 */
export const scDataUnlistedModels = (
    params?: MaybeRefOrGetter<ScDataUnlistedModelsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ScDataUnlistedModels>(
      {url: `/unlisted-models`, method: 'GET',
        params, signal
    },
      );
    }




export const getScDataUnlistedModelsQueryKey = (params?: MaybeRefOrGetter<ScDataUnlistedModelsParams>,) => {
    return [
    'unlisted-models', ...(params ? [params] : [])
    ] as const;
    }


export const getScDataUnlistedModelsQueryOptions = <TData = Awaited<ReturnType<typeof scDataUnlistedModels>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ScDataUnlistedModelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataUnlistedModels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataUnlistedModelsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataUnlistedModels>>> = ({ signal }) => scDataUnlistedModels(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataUnlistedModels>>, TError, TData>
}

export type ScDataUnlistedModelsQueryResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModels>>>
export type ScDataUnlistedModelsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Unlisted models list
 */

export function useScDataUnlistedModels<TData = Awaited<ReturnType<typeof scDataUnlistedModels>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ScDataUnlistedModelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataUnlistedModels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataUnlistedModelsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Ignore a selection
 */
export const scDataUnlistedModelBulkIgnore = (
    scDataUnlistedModelBulkInput: MaybeRefOrGetter<ScDataUnlistedModelBulkInput>,
 signal?: AbortSignal
) => {
      scDataUnlistedModelBulkInput = toValue(scDataUnlistedModelBulkInput);

      return axiosClient<void>(
      {url: `/unlisted-models/bulk-ignore`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scDataUnlistedModelBulkInput, signal
    },
      );
    }




export const getScDataUnlistedModelBulkIgnoreMutationKey = () => ['scDataUnlistedModelBulkIgnore'] as const;

export const getScDataUnlistedModelBulkIgnoreMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkIgnore>>, TError,ScDataUnlistedModelBulkIgnoreMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkIgnore>>, TError,ScDataUnlistedModelBulkIgnoreMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelBulkIgnoreMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelBulkIgnore>>, ScDataUnlistedModelBulkIgnoreMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  scDataUnlistedModelBulkIgnore(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelBulkIgnoreMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelBulkIgnore>>>
    export type ScDataUnlistedModelBulkIgnoreMutationBody = ScDataUnlistedModelBulkInput
    export type ScDataUnlistedModelBulkIgnoreMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ScDataUnlistedModelBulkIgnoreMutationVariables = {data: ScDataUnlistedModelBulkInput}

    /**
 * @summary Ignore a selection
 */
export const useScDataUnlistedModelBulkIgnore = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkIgnore>>, TError,ScDataUnlistedModelBulkIgnoreMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelBulkIgnore>>,
        TError,
        ScDataUnlistedModelBulkIgnoreMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelBulkIgnoreMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark a selection as paints
 */
export const scDataUnlistedModelBulkMarkAsPaint = (
    scDataUnlistedModelBulkInput: MaybeRefOrGetter<ScDataUnlistedModelBulkInput>,
 signal?: AbortSignal
) => {
      scDataUnlistedModelBulkInput = toValue(scDataUnlistedModelBulkInput);

      return axiosClient<void>(
      {url: `/unlisted-models/bulk-mark-as-paint`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scDataUnlistedModelBulkInput, signal
    },
      );
    }




export const getScDataUnlistedModelBulkMarkAsPaintMutationKey = () => ['scDataUnlistedModelBulkMarkAsPaint'] as const;

export const getScDataUnlistedModelBulkMarkAsPaintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkMarkAsPaint>>, TError,ScDataUnlistedModelBulkMarkAsPaintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkMarkAsPaint>>, TError,ScDataUnlistedModelBulkMarkAsPaintMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelBulkMarkAsPaintMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelBulkMarkAsPaint>>, ScDataUnlistedModelBulkMarkAsPaintMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  scDataUnlistedModelBulkMarkAsPaint(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelBulkMarkAsPaintMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelBulkMarkAsPaint>>>
    export type ScDataUnlistedModelBulkMarkAsPaintMutationBody = ScDataUnlistedModelBulkInput
    export type ScDataUnlistedModelBulkMarkAsPaintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ScDataUnlistedModelBulkMarkAsPaintMutationVariables = {data: ScDataUnlistedModelBulkInput}

    /**
 * @summary Mark a selection as paints
 */
export const useScDataUnlistedModelBulkMarkAsPaint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkMarkAsPaint>>, TError,ScDataUnlistedModelBulkMarkAsPaintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelBulkMarkAsPaint>>,
        TError,
        ScDataUnlistedModelBulkMarkAsPaintMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelBulkMarkAsPaintMutationOptions(options), queryClient);
    }
    /**
 * @summary Return a selection to the list
 */
export const scDataUnlistedModelBulkReset = (
    scDataUnlistedModelBulkInput: MaybeRefOrGetter<ScDataUnlistedModelBulkInput>,
 signal?: AbortSignal
) => {
      scDataUnlistedModelBulkInput = toValue(scDataUnlistedModelBulkInput);

      return axiosClient<void>(
      {url: `/unlisted-models/bulk-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scDataUnlistedModelBulkInput, signal
    },
      );
    }




export const getScDataUnlistedModelBulkResetMutationKey = () => ['scDataUnlistedModelBulkReset'] as const;

export const getScDataUnlistedModelBulkResetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkReset>>, TError,ScDataUnlistedModelBulkResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkReset>>, TError,ScDataUnlistedModelBulkResetMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelBulkResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelBulkReset>>, ScDataUnlistedModelBulkResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  scDataUnlistedModelBulkReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelBulkResetMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelBulkReset>>>
    export type ScDataUnlistedModelBulkResetMutationBody = ScDataUnlistedModelBulkInput
    export type ScDataUnlistedModelBulkResetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ScDataUnlistedModelBulkResetMutationVariables = {data: ScDataUnlistedModelBulkInput}

    /**
 * @summary Return a selection to the list
 */
export const useScDataUnlistedModelBulkReset = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelBulkReset>>, TError,ScDataUnlistedModelBulkResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelBulkReset>>,
        TError,
        ScDataUnlistedModelBulkResetMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelBulkResetMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Model
 */
export const scDataUnlistedModelCreateModel = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ScDataUnlistedModel>(
      {url: `/unlisted-models/${id}/create-model`, method: 'POST', signal
    },
      );
    }




export const getScDataUnlistedModelCreateModelMutationKey = () => ['scDataUnlistedModelCreateModel'] as const;

export const getScDataUnlistedModelCreateModelMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelCreateModel>>, TError,ScDataUnlistedModelCreateModelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelCreateModel>>, TError,ScDataUnlistedModelCreateModelMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelCreateModelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelCreateModel>>, ScDataUnlistedModelCreateModelMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  scDataUnlistedModelCreateModel(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelCreateModelMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelCreateModel>>>

    export type ScDataUnlistedModelCreateModelMutationError = ErrorType<ValidationError | StandardError>
    export type ScDataUnlistedModelCreateModelMutationVariables = {id: string}

    /**
 * @summary Create Model
 */
export const useScDataUnlistedModelCreateModel = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelCreateModel>>, TError,ScDataUnlistedModelCreateModelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelCreateModel>>,
        TError,
        ScDataUnlistedModelCreateModelMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelCreateModelMutationOptions(options), queryClient);
    }
    /**
 * @summary Ignore
 */
export const scDataUnlistedModelIgnore = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ScDataUnlistedModel>(
      {url: `/unlisted-models/${id}/ignore`, method: 'POST', signal
    },
      );
    }




export const getScDataUnlistedModelIgnoreMutationKey = () => ['scDataUnlistedModelIgnore'] as const;

export const getScDataUnlistedModelIgnoreMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelIgnore>>, TError,ScDataUnlistedModelIgnoreMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelIgnore>>, TError,ScDataUnlistedModelIgnoreMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelIgnoreMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelIgnore>>, ScDataUnlistedModelIgnoreMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  scDataUnlistedModelIgnore(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelIgnoreMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelIgnore>>>

    export type ScDataUnlistedModelIgnoreMutationError = ErrorType<ValidationError | StandardError>
    export type ScDataUnlistedModelIgnoreMutationVariables = {id: string}

    /**
 * @summary Ignore
 */
export const useScDataUnlistedModelIgnore = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelIgnore>>, TError,ScDataUnlistedModelIgnoreMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelIgnore>>,
        TError,
        ScDataUnlistedModelIgnoreMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelIgnoreMutationOptions(options), queryClient);
    }
    /**
 * @summary Link to a model already in the catalogue
 */
export const scDataUnlistedModelLink = (
    id: MaybeRefOrGetter<string>,
    scDataUnlistedModelLinkInput: MaybeRefOrGetter<ScDataUnlistedModelLinkInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
scDataUnlistedModelLinkInput = toValue(scDataUnlistedModelLinkInput);

      return axiosClient<ScDataUnlistedModel>(
      {url: `/unlisted-models/${id}/link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scDataUnlistedModelLinkInput, signal
    },
      );
    }




export const getScDataUnlistedModelLinkMutationKey = () => ['scDataUnlistedModelLink'] as const;

export const getScDataUnlistedModelLinkMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelLink>>, TError,ScDataUnlistedModelLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelLink>>, TError,ScDataUnlistedModelLinkMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelLink>>, ScDataUnlistedModelLinkMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  scDataUnlistedModelLink(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelLinkMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelLink>>>
    export type ScDataUnlistedModelLinkMutationBody = ScDataUnlistedModelLinkInput
    export type ScDataUnlistedModelLinkMutationError = ErrorType<ValidationError | StandardError>
    export type ScDataUnlistedModelLinkMutationVariables = {id: string;data: ScDataUnlistedModelLinkInput}

    /**
 * @summary Link to a model already in the catalogue
 */
export const useScDataUnlistedModelLink = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelLink>>, TError,ScDataUnlistedModelLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelLink>>,
        TError,
        ScDataUnlistedModelLinkMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelLinkMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark As Paint
 */
export const scDataUnlistedModelMarkAsPaint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ScDataUnlistedModel>(
      {url: `/unlisted-models/${id}/mark-as-paint`, method: 'POST', signal
    },
      );
    }




export const getScDataUnlistedModelMarkAsPaintMutationKey = () => ['scDataUnlistedModelMarkAsPaint'] as const;

export const getScDataUnlistedModelMarkAsPaintMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelMarkAsPaint>>, TError,ScDataUnlistedModelMarkAsPaintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelMarkAsPaint>>, TError,ScDataUnlistedModelMarkAsPaintMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelMarkAsPaintMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelMarkAsPaint>>, ScDataUnlistedModelMarkAsPaintMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  scDataUnlistedModelMarkAsPaint(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelMarkAsPaintMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelMarkAsPaint>>>

    export type ScDataUnlistedModelMarkAsPaintMutationError = ErrorType<ValidationError | StandardError>
    export type ScDataUnlistedModelMarkAsPaintMutationVariables = {id: string}

    /**
 * @summary Mark As Paint
 */
export const useScDataUnlistedModelMarkAsPaint = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelMarkAsPaint>>, TError,ScDataUnlistedModelMarkAsPaintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelMarkAsPaint>>,
        TError,
        ScDataUnlistedModelMarkAsPaintMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelMarkAsPaintMutationOptions(options), queryClient);
    }
    /**
 * @summary Reset
 */
export const scDataUnlistedModelReset = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ScDataUnlistedModel>(
      {url: `/unlisted-models/${id}/reset`, method: 'POST', signal
    },
      );
    }




export const getScDataUnlistedModelResetMutationKey = () => ['scDataUnlistedModelReset'] as const;

export const getScDataUnlistedModelResetMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelReset>>, TError,ScDataUnlistedModelResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelReset>>, TError,ScDataUnlistedModelResetMutationVariables, TContext> => {

const mutationKey = getScDataUnlistedModelResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scDataUnlistedModelReset>>, ScDataUnlistedModelResetMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  scDataUnlistedModelReset(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScDataUnlistedModelResetMutationResult = NonNullable<Awaited<ReturnType<typeof scDataUnlistedModelReset>>>

    export type ScDataUnlistedModelResetMutationError = ErrorType<ValidationError | StandardError>
    export type ScDataUnlistedModelResetMutationVariables = {id: string}

    /**
 * @summary Reset
 */
export const useScDataUnlistedModelReset = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scDataUnlistedModelReset>>, TError,ScDataUnlistedModelResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof scDataUnlistedModelReset>>,
        TError,
        ScDataUnlistedModelResetMutationVariables,
        TContext
      > => {
      return useMutation(getScDataUnlistedModelResetMutationOptions(options), queryClient);
    }
